// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2NM0h","row":"styles_row__hFCi5"};